import { Label } from './ui/label';
import { Card } from './ui/card';
import { getAllCategories, getSubcategories } from '../data/categories';
import { X } from 'lucide-react';

/**
 * Composant pour sélectionner jusqu'à 3 catégories pour une offre
 */
const TripleCategorySelector = ({ categories, onChange }) => {
  const allCategories = getAllCategories();

  const handleCategoryChange = (index, categoryId) => {
    const newCategories = [...categories];
    newCategories[index] = {
      category: categoryId,
      subcategory: ''
    };
    onChange(newCategories);
  };

  const handleSubcategoryChange = (index, subcategory) => {
    const newCategories = [...categories];
    newCategories[index].subcategory = subcategory;
    onChange(newCategories);
  };

  const clearCategory = (index) => {
    const newCategories = [...categories];
    newCategories[index] = { category: '', subcategory: '' };
    onChange(newCategories);
  };

  const getAvailableSubcategories = (categoryId) => {
    return categoryId ? getSubcategories(categoryId) : [];
  };

  return (
    <div className="space-y-4">
      <Label className="text-base font-semibold">
        Catégories (sélectionnez jusqu'à 3)
      </Label>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {[0, 1, 2].map((index) => {
          const selectedCategory = categories[index]?.category || '';
          const selectedSubcategory = categories[index]?.subcategory || '';
          const subcategories = getAvailableSubcategories(selectedCategory);
          const categoryData = allCategories.find(c => c.id === selectedCategory);

          return (
            <Card key={index} className="p-4 space-y-3">
              <div className="flex items-center justify-between">
                <Label className="text-sm font-medium text-gray-700">
                  Catégorie {index + 1}
                </Label>
                {selectedCategory && (
                  <button
                    type="button"
                    onClick={() => clearCategory(index)}
                    className="text-gray-400 hover:text-red-500"
                  >
                    <X className="w-4 h-4" />
                  </button>
                )}
              </div>

              {/* Sélecteur de catégorie */}
              <select
                value={selectedCategory}
                onChange={(e) => handleCategoryChange(index, e.target.value)}
                className="w-full bg-white border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-purple-500 text-sm"
              >
                <option value="">Choisir une catégorie</option>
                {allCategories.map((cat) => (
                  <option key={cat.id} value={cat.id}>
                    {cat.name}
                  </option>
                ))}
              </select>

              {/* Badge de catégorie sélectionnée */}
              {selectedCategory && categoryData && (
                <div
                  className="px-3 py-1.5 rounded-md text-sm font-medium text-center"
                  style={{
                    backgroundColor: categoryData.color + '20',
                    color: categoryData.color
                  }}
                >
                  {categoryData.name}
                </div>
              )}

              {/* Sélecteur de sous-catégorie */}
              {selectedCategory && subcategories.length > 0 && (
                <div className="space-y-2">
                  <Label className="text-xs text-gray-600">Sous-catégorie</Label>
                  <select
                    value={selectedSubcategory}
                    onChange={(e) => handleSubcategoryChange(index, e.target.value)}
                    className="w-full bg-white border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-purple-500 text-sm"
                  >
                    <option value="">Choisir (optionnel)</option>
                    {subcategories.map((subcat, idx) => (
                      <option key={idx} value={subcat}>
                        {subcat}
                      </option>
                    ))}
                  </select>
                </div>
              )}
            </Card>
          );
        })}
      </div>

      {/* Résumé des sélections */}
      <div className="text-sm text-gray-600">
        {categories.filter(c => c.category).length > 0 ? (
          <p>
            ✅ {categories.filter(c => c.category).length} catégorie(s) sélectionnée(s)
          </p>
        ) : (
          <p className="text-orange-600">
            ⚠️ Sélectionnez au moins une catégorie
          </p>
        )}
      </div>
    </div>
  );
};

export default TripleCategorySelector;
